module.exports = __webpack_public_path__ + "static/media/img-mygood-product-3.16f45963.png";